module.exports = __webpack_public_path__ + "img/hiroshima.17ff0b65.png";